require('./preContractualMailInfoAlt.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { formatText, FormattedText, FormattedTextWithNamedVariables } = require('core/i18n').i18n;

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
//@components
const ContractsConfirmationCheckboxGroup = require('../../../routes/contractsView/components/ContractsConfirmationCheckboxGroup/ContractsConfirmationCheckboxGroup');
const LegalTextBlock = require('../legalTextBlock/legalTextBlock');
const { withRouter } = require('react-router-dom');
import classNames from 'classnames';
import { OKMessage, MESSAGE_TYPE_ASSISTANT } from 'commonsComponents/OKMessage'

// @Constants
import { 
    SAVINGS_WITHOUT_CONDITION_WITHOUT_TERM,
    SAVINGS_WITHOUT_CONDITION_WITH_TERM,
    SAVINGS_WITH_CONDITION_WITHOUT_TERM,
    SAVINGS_WITH_CONDITION_WITH_TERM
} from 'constants/eAccountLoan'
import { getNamedVariables, handleSimplifyObject } from 'utilities/depositHelper';

const ACCOUNT_KEY_SUFFIX = {
    'checking-account': '_checkingAccount',
    'payroll-account': '_payrollAccount',
    'upgrade-to-payroll-account': '_payrollConversionAccount',
}

class PreContractualMailInfoAlt extends React.Component {
    constructor(props) {
        super(props);
        this.handleSendPreContractualInfo = this.handleSendPreContractualInfo.bind(this);
        this.handleClientEmailRefresh = this.handleClientEmailRefresh.bind(this);
        this.handleTextRead = this.handleTextRead.bind(this);
    }

    handleClientEmailRefresh() {
        const { requestProfile, tagRefreshMailEvent, history } = this.props;
        requestProfile(history);
        if (!!tagRefreshMailEvent) {
            tagRefreshMailEvent()
        }
    }

    handleSendPreContractualInfo() {
        const { preContractualMailPolling, sendEmail, sendMailParams, tagSendEmailEvent } = this.props;
        sendEmail(sendMailParams, preContractualMailPolling.get('operationProcessId'));
        if (!!tagSendEmailEvent) {
            tagSendEmailEvent();
        }
    }

    buildLegalTextArea() {
        const { showLegalTextAreaAsWarning, legalTextAreaLabel, hasPolling, uniqueLegalKey, contractName, uniqueLegalValues, eAccountType, depositLegalText } = this.props;
        const accountKey = hasPolling && ACCOUNT_KEY_SUFFIX[contractName] ? ACCOUNT_KEY_SUFFIX[contractName] : '';
        let relevantInfo = legalTextAreaLabel || formatText('legalConfirmation-readRelevantInformation' + accountKey);
        relevantInfo = showLegalTextAreaAsWarning ? formatText('legalConfirmation-readRelevantInfoWarning') : relevantInfo;
        const readRelevantInformation = (<HTMLSafeInjector message={relevantInfo} />);
        const mandatoryReading = (<HTMLSafeInjector message={formatText('legalConfirmation-mandatoryReading' + accountKey)} />);
        const indicativeOfRisk = (<HTMLSafeInjector message={formatText('legalConfirmation-indicativeOfRisk' + accountKey)} />);
        const depositsGuaranteeFound = (<HTMLSafeInjector message={formatText('legalConfirmation-depositsGuaranteeFound' + accountKey)} />);
        const liquidityAlert = <HTMLSafeInjector message={formatText('legalConfirmation-liquidityAlert')} />;
        let content = null;
        switch (contractName) {
            case 'open-young':
            case 'open-debit':
            case 'mini-card':
            case 'diamond-pack':
            case 'premium-pack':
            case 'visa-open':
            case 'pre-granted-credit':
            case 'via-t':
            case 'solidario':
            case 'at-home-abroad':
            case 'virtual-credit':
            case 'revolving':
            case 'virtual-only-debit':
            case 'maestro':
            case 'metallic':
                content = (
                    <div>
                        {readRelevantInformation}
                    </div>
                );
                break;
            case 'e-account-loan':
                let eAccountLegalPoeKey = ''
                
                if (eAccountType === SAVINGS_WITHOUT_CONDITION_WITHOUT_TERM) {
                    eAccountLegalPoeKey = 'cc_legalConfirmation-readWithoutBonusWithoutTerm'
                }

                if (eAccountType === SAVINGS_WITHOUT_CONDITION_WITH_TERM) {
                    eAccountLegalPoeKey = 'cc_legalConfirmation-readWithoutBonusWithTerm'
                }

                if (eAccountType === SAVINGS_WITH_CONDITION_WITHOUT_TERM) {
                    eAccountLegalPoeKey = 'cc_legalConfirmation-readWithBonusWithoutTerm'
                }

                if (eAccountType === SAVINGS_WITH_CONDITION_WITH_TERM) {
                    eAccountLegalPoeKey = 'cc_legalConfirmation-readWithBonusWithTerm'
                }

                content = (
                    <div>
                        <HTMLSafeInjector message={formatText(eAccountLegalPoeKey)} />
                    </div>
                );
                break;
            case 'junior-account':
            case 'checking-account':
            case 'payroll-account':
            case 'upgrade-to-payroll-account':
                content = (
                    <div>
                        {readRelevantInformation}
                        {mandatoryReading}
                        { (accountKey !=='_payrollConversionAccount' && accountKey !=='_payrollAccount' && accountKey !== '_checkingAccount') &&
                        <ul>
                            <li>{indicativeOfRisk}</li>
                            <li>{depositsGuaranteeFound}</li>
                        </ul>
                        }
                    </div>
                );
                break;
            case 'deposit-thirteen-months':
            case 'deposit-thirteen-months-due-dates':
            case 'deposit-thirteen-months-excepciones':
            case 'deposit-thirteen-months-leak-retention':
            case 'deposit-thirteen-months-linked-maturities':
            case 'deposit-thirteen-months-renovacion-excepciones':
                content = (
                    <div>
                        {readRelevantInformation}
                        {mandatoryReading}
                        <ul>
                            <li>{indicativeOfRisk}</li>
                            <li>{depositsGuaranteeFound}</li>
                            <li>{liquidityAlert}</li>
                        </ul>
                    </div>
                );
                break;
            case 'depositnm':
            case 'deposit':
            case 'depositexpired':
            case 'deposittransfer':
            case 'depositrenewal':
            case 'depositpayroll':
                if (!depositLegalText.isFetched) {
                    break;
                }
                const depositLegalValues = handleSimplifyObject(depositLegalText)
                const namedVariablesValues = getNamedVariables(uniqueLegalKey, depositLegalValues);

                content = (
                    <div>
                        <FormattedTextWithNamedVariables value={uniqueLegalKey} namedVariables={namedVariablesValues} />
                    </div>
                )
        }

        return content;
    }

    buildSendPreContractualButton(hasBeenSent, isFetching) {
        let message;
        const { preContractualMail, email, disableSendButton, loadingSendButton } = this.props;
        const textPreContactualMailButton = formatText("preContractualMailInfo-textPreContactualMailButton");
        const loading = isFetching;
        const mailError = preContractualMail.get('error');

        if (mailError) {
            message = formatText('preContractualMailInfo-errorMailSend');
        } else if (hasBeenSent) {
            message = formatText('preContractualMailInfo-successMailSend');
        }
        return (
            <div className="pre-contractual-mail-alt__button">
                <OKButton
                    modifier="primary"
                    onClick={this.handleSendPreContractualInfo}
                    loading={loading || loadingSendButton}
                    disabled={!email || disableSendButton}
                >
                    {textPreContactualMailButton}
                </OKButton>
                <p className="pre-contractual-mail-alt__button-error">{message}</p>
            </div>
        );
    }

    handleTextRead() {
        const { isLegalTextRead, onLegalTextRead } = this.props;
        !isLegalTextRead && onLegalTextRead && onLegalTextRead();
    }

    buildLegalTextBlock() {
        const { showLegalText, showLegalTextAreaAsWarning, alternativeLegalTextHeight, component: { isMandatoryRead } } = this.props;
        const textVal = formatText("preContractualMailInfo-textLabel");
        const textAreaContent = this.buildLegalTextArea();
        const textValueClassName = classNames('pre-contractual-mail-alt__text-value', {
            'block-info-title': isMandatoryRead
        })

        return showLegalText ? (
            <div>
                <div className={textValueClassName}>
                    {isMandatoryRead && <i className="block-info-title__icon-assistant"></i>}
                    {textVal}
                </div>
                <div className="pre-contractual-mail-alt__textarea">
                    {showLegalTextAreaAsWarning ?
                        <div className="pre-contractual-mail-alt__warning-box">
                            <i className="icon-warning"></i>
                            <div className="pre-contractual-mail-alt__legal-text">
                                {textAreaContent}
                            </div>
                        </div> :
                        <LegalTextBlock textContent={textAreaContent} onTextRead={this.handleTextRead} alternativeHeight={alternativeLegalTextHeight} />
                    }
                </div>
            </div>
        ) : null;
    }

    buildLegalInfoText() {
        const { legalInfoText } = this.props;
        const information = formatText('preContractualMailInfo-information');
        return legalInfoText ? (
            <div className="pre-contractual-mail-alt__information">
                <i className="icon-informacion"></i>
                {information}
            </div>
        ) : null;

    }

    render() {
        const {
            email,
            documentId,
            getDocumentsOkApiById,
            preContractualMail,
            profileError,
            showMailSendButton,
            updateConfirmationCheckboxes,
            confirmationCheckboxes,
            precontractualLink,
            areDisabled,
            setTermsAndCondsText,
            alternativePositionedCheckboxes,
            customCategoryEvent,
            match,
            getPrecontractualDocumentURLOrID,
            originCountry,
            contractWizard,
            component,
            contractBuilder,
        } = this.props;

        const hasBeenSent = preContractualMail.get('mailSent');
        const isFetching = preContractualMail.get('isFetching');
        const sendPreContractualButton = this.buildSendPreContractualButton(hasBeenSent, isFetching);
        const emailTitle = formatText('preContractualMailInfo-emailTitle');
        const errorMailRefresh = profileError ? formatText('preContractualMailInfo-errorMailRefresh') : '';
        const legalTextBlock = this.buildLegalTextBlock();
        const legalInfoBlock = this.buildLegalInfoText();
        const emailholder = email ? email : formatText('preContractualMailInfo-emailPlaceholder');
        const { isMandatoryRead, readTextTitle, readTextInfo, getTextValues } = component;
        let textValues = undefined;
        if (getTextValues) {
            textValues = contractBuilder[getTextValues]({contractWizard});
        }

        const checkboxGroup = (
            <ContractsConfirmationCheckboxGroup
                updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                confirmationCheckboxes={confirmationCheckboxes}
                documentId={documentId}
                getDocumentsOkApiById={getDocumentsOkApiById}
                precontractualLink={precontractualLink}
                areDisabled={areDisabled}
                setTermsAndCondsText={setTermsAndCondsText}
                customCategoryEvent={customCategoryEvent}
                match={match}
                getPrecontractualDocumentURLOrID={getPrecontractualDocumentURLOrID}
                originCountry={originCountry}
                contractWizard={contractWizard}
            />
        );
        return (
            <div className="pre-contractual-mail">
                {legalTextBlock}
                {
                    isMandatoryRead && (
                        <div className="pre-contractual-mail-alt__read-text">
                            <OKMessage type={MESSAGE_TYPE_ASSISTANT}>
                                <p className='message__title'><FormattedText value={readTextTitle} /></p>
                                <FormattedText value={readTextInfo} injectedStrings={textValues} />
                            </OKMessage>
                        </div>
                    )
                }
                {!alternativePositionedCheckboxes ? checkboxGroup : null}
                <div className="pre-contractual-mail__email-container">
                    <div className="pre-contractual-mail__email">
                        <p className="pre-contractual-mail__title-email">{emailTitle}</p>
                        <span className="pre-contractual-mail__email-text">
                            {emailholder}
                        </span>
                        <OKButton
                            modifier="tasks-transparent"
                            size="medium"
                            onClick={this.handleClientEmailRefresh}
                        >
                            <i className="icon-refrescar"></i>
                        </OKButton>
                        <p className="pre-contractual-mail__refresh-error">{errorMailRefresh}</p>
                    </div>
                    <p className="pre-contractual-mail__error-mail-refresh">{''}</p>
                </div>
                <div className="pre-contractual-mail__button-container">
                    {showMailSendButton && sendPreContractualButton}
                </div>
                {legalInfoBlock}
                {alternativePositionedCheckboxes ? checkboxGroup : null}
            </div>
        );
    }
}

PreContractualMailInfoAlt.propTypes = {
    alternativeLegalTextHeight: PropTypes.string,
    alternativePositionedCheckboxes: PropTypes.bool,
    depositLegalText: PropTypes.object,
    disableSendButton: PropTypes.bool,
    documentId: PropTypes.string,
    email: PropTypes.string.isRequired,
    getDocumentsOkApiById: PropTypes.func,
    sendEmail: PropTypes.func.isRequired,
    onLegalTextRead: PropTypes.func,
    sendMailParams: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    preContractualMailPolling: PropTypes.object.isRequired,
    profileError: PropTypes.string,
    contractName: PropTypes.string,
    legalTextAreaLabel: PropTypes.string,
    loadingSendButton: PropTypes.bool,
    showLegalText: PropTypes.bool.isRequired,
    legalInfoText: PropTypes.bool.isRequired,
    showLegalTextAreaAsWarning: PropTypes.bool,
    showMailSendButton: PropTypes.bool,
    confirmationCheckboxes: PropTypes.object.isRequired,
    updateConfirmationCheckboxes: PropTypes.func.isRequired,
    uniqueLegalKey: PropTypes.string,
    precontractualLink: PropTypes.string,
    areDisabled: PropTypes.bool,
    setTermsAndCondsText: PropTypes.func,
    tagSendEmailEvent: PropTypes.func,
    tagRefreshMailEvent: PropTypes.func,
    isLegalTextRead: PropTypes.bool,
    hasPolling: PropTypes.bool,
    history: PropTypes.object.isRequired,
    contractWizard: PropTypes.object.isRequired,
    customCategoryEvent: PropTypes.string
};

PreContractualMailInfoAlt.defaultProps = {
    disableSendButton: false,
    documentId: null,
    getDocumentsOkApiById: () => { },
    hasPolling: false,
    showLegalText: true,
    legalTextArea: null,
    legalInfoText: true,
    legalTextAreaLabel: '',
    loadingSendButton: false,
    showLegalTextAreaAsWarning: false,
    showMailSendButton: true,
    onLegalTextRead: null,
    customCategoryEvent: null
}

module.exports = withRouter(PreContractualMailInfoAlt);